import './BannerBlock.scss'
import {Autoplay} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import {generateFileMediaUrl} from "../../../utils/generateMediaUrl";
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {connect} from "react-redux";


function BannerBlock(props){
    const {sliderBanner} = props
    const banner = []
    banner.push(sliderBanner)
    const bannerList = Array.isArray(sliderBanner) ?  sliderBanner : banner


    return <div className={'bannerBlock-wrapper'}>
        <Swiper
            spaceBetween={30}
            centeredSlides={true}
            loop={true}
            autoplay={{
                delay: 2500,
                disableOnInteraction: false,
            }}
            pagination={{
                clickable: true,
            }}
            navigation={false}
            modules={[Autoplay]}
            className="mySwiper"
        >
            {
             bannerList.length && bannerList?.map((item,index) => {
                    return <SwiperSlide>
                        <a href={item?.link} target={'_blank'}>
                            <div  className={'bannerBlock-img'}>
                                <img src={generateFileMediaUrl(item?.mediaMain?.path)} alt=""/>
                            </div>
                        </a>
                    </SwiperSlide>
                })
            }
        </Swiper>
    </div>
}const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
    ])
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps,mapDispatchToProps)(BannerBlock);